<script setup>
import SearchString from "@/components/table/SearchString.vue";
import { defineProps, defineEmits, defineModel, inject } from "vue";

defineProps({
  selectedItems: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(["openDeleteModal", "openCreateModal", "openUploadModal", "saveChanges"]); 

const editedItems = inject("editedItems");

const model = defineModel();

</script>

<template>
  <div class="navbar-wrapper">
    <SearchString v-model="model" />
    <ButtonAccentPrimary
      size="large"
      :disabled="selectedItems.length === 0"
      @click="selectedItems.length > 0 ? emit('openDeleteModal') : false"
    >
      <i class="icon-trash" />
      Удалить
    </ButtonAccentPrimary>
    <ButtonNeutralSecondary @click="emit('openCreateModal')">
      <i class="icon-plus" />
      Новый тег
    </ButtonNeutralSecondary>
    <ButtonAccentPrimary
      size="large"
      :disabled="editedItems.length === 0"
      @click="emit('saveChanges')"
    >
      Сохранить изменения
    </ButtonAccentPrimary>
  </div>
</template>

<style scoped lang="scss">
.navbar {
  &-wrapper {
    display: grid;
    grid-template-columns: 3.5fr 0.5fr 1fr 1fr;
    grid-gap: 24px;
    margin: 16px 0;
  }
}
</style>